import { TrackingModel } from '../..';
import * as S from './styles';

interface TrackingHeaders {
  titles: Array<string>;
  data: Array<TrackingModel>;
}

const Tracking = ({ titles, data }: TrackingHeaders) => {
  if (data.length === 0) {
    return <S.EmptyContent>Ainda não há rastreio</S.EmptyContent>;
  }
  return (
    <>
      <S.TableHeader>
        {titles.map(title => (
          <span key={title}>{title}</span>
        ))}
      </S.TableHeader>
      <S.TableBody>
        {data.map(item => (
          <S.TableRow key={item.start}>
            <span>{item.status}</span>
            <span>
              {new Date(item.start).toLocaleString('pt-BR', {
                timeZone: 'UTC',
              })}
            </span>
            <span>
              {item.end &&
                new Date(item.end).toLocaleString('pt-BR', {
                  timeZone: 'UTC',
                })}
            </span>
          </S.TableRow>
        ))}
      </S.TableBody>
    </>
  );
};

export default Tracking;
